import numbro from 'numbro';

import { EDisplayType } from '../types';

export const STABLECOIN_NAME = 'VST';
export const PROTOCOL_NAME = 'Vesta Finance';
export const GOVERNANCE_TOKEN_NAME = 'VSTA';

export function DisplayFormat(value: number, displayType: EDisplayType, decimal?: number) {
  switch (displayType) {
    case EDisplayType.USD: {
      return numbro(value).format({
        currencySymbol: '',
        thousandSeparated: true,
        average: false,
        mantissa: decimal ?? 2,
      });
    }
    case EDisplayType.Percent: {
      if (Number.isNaN(value)) return '-';
      return value === 0 ? '0' : value >= 0.01 ? '' + (value * 100).toFixed(2) : '< 0.01';
    }
    case EDisplayType.number: {
      if (Number.isNaN(value)) return 'N/A';
      return value.toFixed(decimal);
    }
    case EDisplayType.ShortUSD: {
      return numbro(value).formatCurrency({
        ...shortBase(),
        currencySymbol: '$',
        currencyPosition: 'prefix',
      });
    }
    case EDisplayType.ShortVST: {
      return numbro(value).formatCurrency({
        ...shortBase(value),
        currencySymbol: ' VST',
        currencyPosition: 'postfix',
      });
    }
    case EDisplayType.VST: {
      return numbro(value).formatCurrency({
        mantissa: 2,
        thousandSeparated: true,
        currencySymbol: ' VST',
        currencyPosition: 'postfix',
      });
    }
    case EDisplayType.Token: {
      return numbro(value).format({
        mantissa: 2,
        thousandSeparated: true,
      });
    }
  }
  return '';
}

const shortBase = (value?: number) => ({
  mantissa: 2,
  thousandSeparated: true,
  average: !value || value > 99999 ? true : false,
  totalLength: !value || value > 99999 ? 4 : 0,
});

// @TODO replace all displayformat with this in future
export function displayFormatUnits({
  value,
  displayType,
  decimal,
  unit,
  disablePercentEst = false,
}: {
  value: number | string;
  displayType: EDisplayType;
  decimal?: number;
  unit?: string;
  disablePercentEst?: boolean;
}) {
  const numberValue = typeof value === 'string' ? Number(value) : value;

  if (Number.isNaN(numberValue)) return 'N/A';
  switch (displayType) {
    case EDisplayType.USD: {
      return `$${numbro(numberValue).format({
        thousandSeparated: true,
        average: false,
        mantissa: decimal ?? 2,
      })}`;
    }
    case EDisplayType.Percent: {
      const res =
        numberValue === 0
          ? '0'
          : numberValue >= 0.0001 || disablePercentEst
          ? '' +
            numbro(numberValue * 100).format({
              mantissa: typeof decimal === 'number' ? decimal : 2,
              trimMantissa: true,
            })
          : '< 0.01';
      return `${res}%`;
    }
    case EDisplayType.number: {
      return unit
        ? `${numbro(numberValue).format({
            mantissa: decimal || 0,
            thousandSeparated: true,
            trimMantissa: true,
          })} ${unit}`
        : `${numbro(numberValue).format({
            mantissa: decimal || 0,
            thousandSeparated: true,
            trimMantissa: true,
          })}`;
    }
    case EDisplayType.ShortUSD: {
      return numbro(numberValue).formatCurrency({
        ...shortBase(),
        currencySymbol: '$ ',
        mantissa: typeof decimal === 'number' ? decimal : 2,
        currencyPosition: 'prefix',
        trimMantissa: true,
      });
    }
    case EDisplayType.ShortVST: {
      return numbro(numberValue).format({
        mantissa: 2,
        average: true,
        thousandSeparated: true,
        trimMantissa: true,
      });
    }
    case EDisplayType.VST: {
      return numbro(numberValue).formatCurrency({
        mantissa: typeof decimal === 'number' ? decimal : 0,
        thousandSeparated: true,
        currencySymbol: ' VST',
        currencyPosition: 'postfix',
      });
    }
    case EDisplayType.Token: {
      const hasUnit = unit ? ` ${unit}` : '';
      if (numberValue === 0) return `0${hasUnit}`;
      if (numberValue < 0.01) return `< 0.01${hasUnit}`;
      return `${numbro(numberValue).format({
        mantissa: decimal ? decimal : numberValue > 0 ? 2 : 0,
        thousandSeparated: true,
        trimMantissa: true,
      })}${hasUnit}`;
    }
    case EDisplayType.NoTruncating: {
      if (numberValue === 0) return '0';
      if (numberValue < (decimal ? 1 / 10 ** decimal : 0.01)) return '< 0.01';
      return numbro(numberValue.toPrecision(decimal ? decimal : 2)).format({
        thousandSeparated: true,
        trimMantissa: true,
      });
    }
  }
}
